import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { ref, set, get, child } from "firebase/database";
import { auth, database } from "../firebase";
import "./RegisterPage.css";

const RegisterPage = () => {
  const navigate = useNavigate();
  const [countryCode, setCountryCode] = useState("+91");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [showWelcome, setShowWelcome] = useState(false); // 👈 Welcome popup state

  const phoneLengthByCountry = {
  "+1": 11,
  "+6": 11,
  "+7": 11,
  "+8": 9,
  "+9": 9,
  "+10": 11,
  "+11": 10,
  "+12": 11,
  "+13": 11,
  "+14": 10,
  "+15": 11,
  "+16": 11,
  "+17": 9,
  "+18": 10,
  "+19": 10,
  "+20": 9,
  "+21": 11,
  "+22": 9,
  "+23": 10,
  "+24": 10,
  "+25": 11,
  "+26": 10,
  "+27": 10,
  "+28": 10,
  "+29": 10,
  "+30": 9,
  "+31": 11,
  "+32": 10,
  "+33": 11,
  "+34": 11,
  "+35": 10,
  "+36": 10,
  "+37": 9,
  "+38": 10,
  "+39": 10,
  "+40": 11,
  "+41": 11,
  "+42": 11,
  "+43": 9,
  "+44": 10,
  "+45": 9,
  "+46": 10,
  "+47": 9,
  "+48": 11,
  "+49": 11,
  "+50": 11,
  "+51": 10,
  "+52": 11,
  "+53": 10,
  "+54": 9,
  "+55": 10,
  "+56": 9,
  "+57": 10,
  "+58": 11,
  "+59": 10,
  "+60": 10,
  "+61": 11,
  "+62": 9,
  "+63": 11,
  "+64": 10,
  "+65": 11,
  "+66": 10,
  "+67": 11,
  "+68": 10,
  "+69": 10,
  "+70": 11,
  "+71": 9,
  "+72": 9,
  "+73": 9,
  "+74": 9,
  "+75": 9,
  "+76": 10,
  "+77": 9,
  "+78": 9,
  "+79": 10,
  "+80": 11,
  "+81": 10,
  "+82": 10,
  "+83": 11,
  "+84": 10,
  "+85": 9,
  "+86": 11,
  "+87": 11,
  "+88": 9,
  "+89": 10,
  "+90": 11,
  "+91": 10,
  "+92": 10,
  "+93": 9,
  "+94": 11,
  "+95": 9,
  "+96": 10,
  "+97": 10,
  "+98": 9,
  "+99": 10,
  "+100": 11,
  "+101": 11,
  "+102": 10,
  "+103": 11,
  "+104": 10,
  "+105": 9,
  "+106": 11,
  "+107": 9,
  "+108": 9,
  "+109": 10,
  "+110": 10,
  "+111": 9,
  "+112": 10,
  "+113": 11,
  "+114": 10,
  "+115": 11,
  "+116": 9,
  "+117": 9,
  "+118": 9,
  "+119": 10,
  "+120": 10,
  "+121": 10,
  "+122": 9,
  "+123": 10,
  "+124": 10,
  "+125": 10,
  "+126": 11,
  "+127": 10,
  "+128": 10,
  "+129": 10,
  "+130": 11,
  "+131": 9,
  "+132": 10,
  "+133": 10,
  "+134": 11,
  "+135": 9,
  "+136": 10,
  "+137": 11,
  "+138": 9,
  "+139": 10,
  "+140": 9,
  "+141": 9,
  "+142": 10,
  "+143": 9,
  "+144": 9,
  "+145": 11,
  "+146": 9,
  "+147": 9,
  "+148": 11,
  "+149": 11,
  "+150": 9,
  "+151": 10,
  "+152": 9,
  "+153": 10,
  "+154": 11,
  "+155": 11,
  "+156": 11,
  "+157": 10,
  "+158": 11,
  "+159": 11,
  "+160": 9,
  "+161": 11,
  "+162": 11,
  "+163": 9,
  "+164": 9,
  "+165": 9,
  "+166": 10,
  "+167": 10,
  "+168": 9,
  "+169": 9,
  "+170": 11,
  "+171": 11,
  "+172": 11,
  "+173": 9,
  "+174": 9,
  "+175": 9,
  "+176": 10,
  "+177": 9,
  "+178": 9,
  "+179": 11,
  "+180": 10,
  "+181": 9,
  "+182": 11,
  "+183": 10,
  "+184": 9,
  "+185": 9,
  "+186": 9,
  "+187": 11,
  "+188": 11,
  "+189": 9,
  "+190": 11,
  "+191": 10,
  "+192": 11,
  "+193": 9,
  "+194": 10,
  "+195": 10,
  "+196": 10,
  "+197": 11,
  "+198": 11,
  "+199": 10,
  "+200": 11,
  "+201": 10,
  "+202": 9,
  "+203": 11,
  "+204": 9,
  "+205": 9,
  "+206": 10,
  "+207": 9,
  "+208": 11,
  "+209": 11,
  "+210": 10,
  "+211": 10,
  "+212": 9,
  "+213": 11,
  "+214": 10,
  "+215": 9,
  "+216": 11,
  "+217": 11,
  "+218": 11,
  "+219": 10,
  "+220": 11,
  "+221": 11,
  "+222": 11,
  "+223": 11,
  "+224": 10,
  "+225": 11,
  "+226": 10,
  "+227": 11,
  "+228": 10,
  "+229": 11,
  "+230": 11,
  "+231": 9,
  "+232": 11,
  "+233": 10,
  "+234": 11,
  "+235": 9,
  "+236": 11,
  "+237": 10,
  "+238": 11,
  "+239": 11,
  "+240": 9,
  "+241": 11,
  "+242": 10,
  "+243": 10,
  "+244": 11,
  "+971":9
};

  const validate = () => {
    const errs = {};
    const expectedLength = phoneLengthByCountry[countryCode] || 10;
    const phoneRegex = new RegExp(`^[0-9]{${expectedLength}}$`);

    if (!phoneRegex.test(phone)) {
      errs.phone = `Phone number must be exactly ${expectedLength} digits for ${countryCode}`;
    }
    if (email && !email.includes("@")) {
      errs.email = "Please enter a valid email address.";
    }
    if (password.length < 6) {
      errs.password = "Password must be at least 6 characters.";
    }
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const fullPhone = phone.trim();
    const syntheticEmail = `${fullPhone}@omillionaire.com`;

    try {
      const userRef = ref(database);
      const snapshot = await get(child(userRef, `users/${fullPhone}`));

      if (snapshot.exists()) {
        setErrors({ phone: "This phone number is already registered." });
        return;
      }

      const allUsersSnap = await get(child(userRef, `users`));
      if (allUsersSnap.exists()) {
        const users = allUsersSnap.val();
        const emailExists = Object.values(users).some(
          (u) => u.email && u.email.toLowerCase() === email.toLowerCase()
        );
        if (emailExists) {
          setErrors({ email: "This email is already registered." });
          return;
        }
      }

      await createUserWithEmailAndPassword(auth, syntheticEmail, password);

      await set(ref(database, `users/${fullPhone}`), {
        phone: fullPhone,
        countryCode,
        email: email || ""
      });

      setShowWelcome(true); // ✅ Show popup

    } catch (error) {
      console.error("🔥 Firebase error:", error.message);
      if (error.code === "auth/email-already-in-use") {
        setErrors({ phone: "Phone already registered. Try logging in." });
      } else {
        alert("Registration failed: " + error.message);
      }
    }
  };

  return (
    <>
      <div className="register-header">
        <div className="logo-left">
          <img src="/easy-play-logo.png" alt="Logo" className="logo" />
        </div>
        <div className="home-right">
          <Link to="/">Home</Link>
        </div>
      </div>

      <div className="register-page">
        <main className="register-main">
          <div className="register-container">
            <h2 className="register-title">Register</h2>
            <form className="register-form" onSubmit={handleSubmit}>
              <div className="form-group phone-group">
                <label>Phone Number</label>
                <div className="phone-input-wrapper">
                  <select
                    value={countryCode}
                    onChange={(e) => setCountryCode(e.target.value)}
                    className="country-code-select"
                  >
                     <option value="+91">🇮🇳 +91 (India)</option>
                   <option value="+93">AF +93 (Afghanistan)</option>
                  <option value="+355">AL +355 (Albania)</option>
                  <option value="+213">DZ +213 (Algeria)</option>
                   <option value="+1-684">AS +1-684 (American )</option>
                  <option value="+376">AD +376 (Andorra )</option>
                  <option value="+244">AO +244 (Angola )</option>
                  <option value="+1-264">AI +1-264 (Anguilla )</option>
                  <option value="+672">AQ +672 (Antarctica )</option>
                  <option value="+1-268">AG +1-268 (Antigua and Barbuda )</option>
                  <option value="+54">AR +54 (Argentina)</option>
                  <option value="+374">AM +374 (Armenia)</option>
                  <option value="+297">AW +297 (Aruba)</option>
                  <option value="+61">AU +61 (Australia)</option>
                  <option value="+43">AT +43 (Austria)</option>
                  <option value="+994">AZ +994 (Azerbaijan)</option>
                  <option value="+1-242">BS +1-242 (Bahamas)</option>
                  <option value="+973">BH +973 (Bahrain)</option>
                  <option value="+880">BD +880 (Bangladesh)</option>
                  <option value="+1-246">BB +1-246 (Barbados)</option>
                  <option value="+375">BY +375 (Belarus)</option>
                  <option value="+32">BE +32 (Belgium)</option>
                  <option value="+501">BZ +501 (Belize)</option>
                  <option value="+229">BJ +229 (Benin)</option>
                  <option value="+1-441">BM +1-441 (Bermuda)</option>
                  <option value="+975">BT +975 (Bhutan)</option>
                  <option value="+591">BO +591 (Bolivia)</option>
                  <option value="+387">BA +387 (Bosnia and Herzegovina)</option>
                  <option value="+267">BW +267 (Botswana)</option>
                  <option value="+55">BR +55 (Brazil)</option>
                  <option value="+246">IO +246 (British Indian Ocean Territory)</option>
                  <option value="+1-284">VG +1-284 (British Virgin Islands)</option>
                  <option value="+673">BN +673 (Brunei)</option>
                  <option value="+359">BG +359 (Bulgaria)</option>
                  <option value="+226">BF +226 (Burkina Faso)</option>
                  <option value="+257">BI +257 (Burundi)</option>
                  <option value="+855">KH +855 (Cambodia)</option>
                  <option value="+237">CM +237 (Cameroon)</option>
                  <option value="+1">CA +1 (Canada)</option>
                  <option value="+238">CV +238 (Cape Verde)</option>
                  <option value="+1-345">KY +1-345 (Cayman Islands)</option>
                  <option value="+236">CF +236 (Central African Republic)</option>
                  <option value="+235">TD +235 (Chad)</option>
                  <option value="+56">CL +56 (Chile)</option>
                  <option value="+86">CN +86 (China)</option>
                  <option value="+61">CX +61 (Christmas Island)</option>
                  <option value="+57">CO +57 (Colombia)</option>
                  <option value="+269">KM +269 (Comoros)</option>
                  <option value="+682">CK +682 (Cook Islands)</option>
                  <option value="+506">CR +506 (Costa Rica)</option>
                  <option value="+385">HR +385 (Croatia)</option>
                  <option value="+53">CU +53 (Cuba)</option>               
<option value="+599">CW +599 (Curacao)</option>
<option value="+357">CY +357 (Cyprus)</option>
<option value="+420">CZ +420 (Czech Republic)</option>
<option value="+243">CD +243 (Democratic Republic of the Congo)</option>
<option value="+45">DK +45 (Denmark)</option>
<option value="+253">DJ +253 (Djibouti)</option>
<option value="+1-767">DM +1-767 (Dominica)</option>
<option value="+1-809, 1-829, 1-849">DO +1-809, 1-829, 1-849 (Dominican Republic)</option>
<option value="+670">TL +670 (East Timor)</option>
<option value="+593">EC +593 (Ecuador)</option>
<option value="+20">EG +20 (Egypt)</option>
<option value="+503">SV +503 (El Salvador)</option>
<option value="+240">GQ +240 (Equatorial Guinea)</option>
<option value="+291">ER +291 (Eritrea)</option>
<option value="+372">EE +372 (Estonia)</option>
<option value="+251">ET +251 (Ethiopia)</option>
<option value="+500">FK +500 (Falkland Islands)</option>
<option value="+298">FO +298 (Faroe Islands)</option>
<option value="+679">FJ +679 (Fiji)</option>
<option value="+358">FI +358 (Finland)</option>
<option value="+33">FR +33 (France)</option>
<option value="+689">PF +689 (French Polynesia)</option>
<option value="+241">GA +241 (Gabon)</option>
<option value="+220">GM +220 (Gambia)</option>
<option value="+995">GE +995 (Georgia)</option>
<option value="+49">DE +49 (Germany)</option>
<option value="+233">GH +233 (Ghana)</option>
<option value="+350">GI +350 (Gibraltar)</option>
<option value="+30">GR +30 (Greece)</option>
<option value="+299">GL +299 (Greenland)</option>
<option value="+1-473">GD +1-473 (Grenada)</option>
<option value="+1-671">GU +1-671 (Guam)</option>
<option value="+502">GT +502 (Guatemala)</option>
<option value="+44-1481">GG +44-1481 (Guernsey)</option>
<option value="+224">GN +224 (Guinea)</option>
<option value="+245">GW +245 (Guinea-Bissau)</option>
<option value="+592">GY +592 (Guyana)</option>
<option value="+509">HT +509 (Haiti)</option>  
<option value="+504">HN +504 (Honduras)</option>
<option value="+852">HK +852 (Hong Kong)</option>
<option value="+36">HU +36 (Hungary)</option>
<option value="+354">IS +354 (Iceland)</option>
<option value="+91">IN +91 (India)</option>
<option value="+62">ID +62 (Indonesia)</option>
<option value="+98">IR +98 (Iran)</option>
<option value="+964">IQ +964 (Iraq)</option>
<option value="+353">IE +353 (Ireland)</option>
<option value="+44-1624">IM +44-1624 (Isle of Man)</option>
<option value="+972">IL +972 (Israel)</option>
<option value="+39">IT +39 (Italy)</option>
<option value="+225">CI +225 (Ivory Coast)</option>
<option value="+1-876">JM +1-876 (Jamaica)</option>
<option value="+81">JP +81 (Japan)</option>
<option value="+44-1534">JE +44-1534 (Jersey)</option>
<option value="+962">JO +962 (Jordan)</option>
<option value="+7">KZ +7 (Kazakhstan)</option>
<option value="+254">KE +254 (Kenya)</option>
<option value="+686">KI +686 (Kiribati)</option>
<option value="+383">XK +383 (Kosovo)</option>
<option value="+965">KW +965 (Kuwait)</option>
<option value="+996">KG +996 (Kyrgyzstan)</option>
<option value="+856">LA +856 (Laos)</option>
<option value="+371">LV +371 (Latvia)</option>
<option value="+961">LB +961 (Lebanon)</option>
<option value="+266">LS +266 (Lesotho)</option>
<option value="+231">LR +231 (Liberia)</option>
<option value="+218">LY +218 (Libya)</option>
<option value="+423">LI +423 (Liechtenstein)</option>
<option value="+370">LT +370 (Lithuania)</option>
<option value="+352">LU +352 (Luxembourg)</option>
<option value="+853">MO +853 (Macao)</option>
<option value="+389">MK +389 (Macedonia)</option>
<option value="+261">MG +261 (Madagascar)</option>
<option value="+265">MW +265 (Malawi)</option>
<option value="+60">MY +60 (Malaysia)</option>
<option value="+960">MV +960 (Maldives)</option>
<option value="+223">ML +223 (Mali)</option>
<option value="+356">MT +356 (Malta)</option>
<option value="+692">MH +692 (Marshall Islands)</option>
<option value="+222">MR +222 (Mauritania)</option>
<option value="+230">MU +230 (Mauritius)</option>
<option value="+262">YT +262 (Mayotte)</option>
<option value="+52">MX +52 (Mexico)</option>
<option value="+691">FM +691 (Micronesia)</option>
<option value="+373">MD +373 (Moldova)</option>
<option value="+377">MC +377 (Monaco)</option>
<option value="+976">MN +976 (Mongolia)</option>
<option value="+382">ME +382 (Montenegro)</option>
<option value="+1-664">MS +1-664 (Montserrat)</option>
<option value="+212">MA +212 (Morocco)</option>
<option value="+258">MZ +258 (Mozambique)</option>
<option value="+95">MM +95 (Myanmar)</option>
<option value="+264">NA +264 (Namibia)</option>
<option value="+674">NR +674 (Nauru)</option>
<option value="+977">NP +977 (Nepal)</option>
<option value="+31">NL +31 (Netherlands)</option>
<option value="+599">AN +599 (Netherlands Antilles)</option>
<option value="+687">NC +687 (New Caledonia)</option>
<option value="+64">NZ +64 (New Zealand)</option>
<option value="+505">NI +505 (Nicaragua)</option>
<option value="+227">NE +227 (Niger)</option>
<option value="+234">NG +234 (Nigeria)</option>
<option value="+683">NU +683 (Niue)</option>
<option value="+850">KP +850 (North Korea)</option>
<option value="+1-670">MP +1-670 (Northern Mariana Islands)</option>
<option value="+47">NO +47 (Norway)</option>
<option value="+968">OM +968 (Oman)</option>
<option value="+92">PK +92 (Pakistan)</option>
<option value="+680">PW +680 (Palau)</option>
<option value="+970">PS +970 (Palestine)</option>
<option value="+507">PA +507 (Panama)</option>
<option value="+675">PG +675 (Papua New Guinea)</option>
<option value="+595">PY +595 (Paraguay)</option>
<option value="+51">PE +51 (Peru)</option>
<option value="+63">PH +63 (Philippines)</option>
<option value="+64">PN +64 (Pitcairn)</option>
<option value="+48">PL +48 (Poland)</option>
<option value="+351">PT +351 (Portugal)</option>
<option value="+1-787, 1-939">PR +1-787, 1-939 (Puerto Rico)</option>
<option value="+974">QA +974 (Qatar)</option>
<option value="+242">CG +242 (Republic of the Congo)</option>
<option value="+262">RE +262 (Reunion)</option>
<option value="+40">RO +40 (Romania)</option>
<option value="+7">RU +7 (Russia)</option>
<option value="+250">RW +250 (Rwanda)</option>
<option value="+590">BL +590 (Saint Barthelemy)</option>
<option value="+290">SH +290 (Saint Helena)</option>
<option value="+1-869">KN +1-869 (Saint Kitts and Nevis)</option>
<option value="+1-758">LC +1-758 (Saint Lucia)</option>
<option value="+590">MF +590 (Saint Martin)</option>
<option value="+508">PM +508 (Saint Pierre and Miquelon)</option>
<option value="+1-784">VC +1-784 (Saint Vincent and the Grenadines)</option>
<option value="+685">WS +685 (Samoa)</option>
<option value="+378">SM +378 (San Marino)</option>
<option value="+239">ST +239 (Sao Tome and Principe)</option>
<option value="+966">SA +966 (Saudi Arabia)</option>
<option value="+221">SN +221 (Senegal)</option>
<option value="+381">RS +381 (Serbia)</option>
<option value="+248">SC +248 (Seychelles)</option>
<option value="+232">SL +232 (Sierra Leone)</option>
<option value="+65">SG +65 (Singapore)</option>
<option value="+1-721">SX +1-721 (Sint Maarten)</option>
<option value="+421">SK +421 (Slovakia)</option>
<option value="+386">SI +386 (Slovenia)</option>
<option value="+677">SB +677 (Solomon Islands)</option>
<option value="+252">SO +252 (Somalia)</option>
<option value="+27">ZA +27 (South Africa)</option>
<option value="+82">KR +82 (South Korea)</option>
<option value="+211">SS +211 (South Sudan)</option>
<option value="+34">ES +34 (Spain)</option>
<option value="+94">LK +94 (Sri Lanka)</option>
<option value="+249">SD +249 (Sudan)</option>
<option value="+597">SR +597 (Suriname)</option>
<option value="+47">SJ +47 (Svalbard and Jan Mayen)</option>
<option value="+268">SZ +268 (Swaziland)</option>
<option value="+46">SE +46 (Sweden)</option>
<option value="+41">CH +41 (Switzerland)</option>
<option value="+963">SY +963 (Syria)</option>
<option value="+886">TW +886 (Taiwan)</option>
<option value="+992">TJ +992 (Tajikistan)</option>
<option value="+255">TZ +255 (Tanzania)</option>
<option value="+66">TH +66 (Thailand)</option>
<option value="+228">TG +228 (Togo)</option>
<option value="+690">TK +690 (Tokelau)</option>
<option value="+676">TO +676 (Tonga)</option>
<option value="+1-868">TT +1-868 (Trinidad and Tobago)</option>
<option value="+216">TN +216 (Tunisia)</option>
<option value="+90">TR +90 (Turkey)</option>
<option value="+993">TM +993 (Turkmenistan)</option>
<option value="+1-649">TC +1-649 (Turks and Caicos Islands)</option>
<option value="+688">TV +688 (Tuvalu)</option>
<option value="+1-340">VI +1-340 (U.S. Virgin Islands)</option>
<option value="+256">UG +256 (Uganda)</option>
<option value="+380">UA +380 (Ukraine)</option>
<option value="+971">AE +971 (United Arab Emirates)</option>
<option value="+44">GB +44 (United Kingdom)</option>
<option value="+1">US +1 (United States)</option>
<option value="+598">UY +598 (Uruguay)</option>
<option value="+998">UZ +998 (Uzbekistan)</option>
<option value="+678">VU +678 (Vanuatu)</option>
<option value="+379">VA +379 (Vatican)</option>
<option value="+58">VE +58 (Venezuela)</option>
<option value="+84">VN +84 (Vietnam)</option>
<option value="+681">WF +681 (Wallis and Futuna)</option>
<option value="+212">EH +212 (Western Sahara)</option>
<option value="+967">YE +967 (Yemen)</option>
<option value="+260">ZM +260 (Zambia)</option>
<option value="+263">ZW +263 (Zimbabwe)</option>
                    {/* Add more countries here */}
                  </select>
                  <input
                    type="text"
                    placeholder="Phone number"
                    value={phone}
                    onChange={(e) =>
                      setPhone(e.target.value.replace(/\D/g, ""))
                    }
                    required
                  />
                </div>
                {errors.phone && <p className="error">{errors.phone}</p>}
              </div>

              <div className="form-group">
                <label>Email (optional)</label>
                <input
                  type="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {errors.email && <p className="error">{errors.email}</p>}
              </div>

              <div className="form-group">
                <label>Password</label>
                <input
                  type="password"
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                {errors.password && <p className="error">{errors.password}</p>}
              </div>

              <button type="submit" className="register-button">
                Register
              </button>
            </form>

            <p className="register-login-text">
              Already have an account? <Link to="/login">Login Now</Link>
            </p>
          </div>
        </main>
      </div>

      {/*  Welcome Popup */}
      {showWelcome && (
        <div className="welcome-popup">
          <div className="popup-content">
            <h3>🎉 Welcome!</h3>
            <p>You're successfully registered! Your winning journey begins now</p>
            <button
              onClick={() => {
                setShowWelcome(false);
                navigate("/", { replace: true });
              }}
            >
              Continue to Home
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default RegisterPage;
